
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import { getRequest } from '@/plugins/api-axios'
import { projectBaseUrl, getRequestHeaders, getURL } from '@/utils/axios'
import { deserialise } from 'kitsu-core'
import lodash from 'lodash'
import { getProject } from '../../../utils/project'

const ProjectAutocomplete = Vue.extend({
    mixins: [AppMixin],
    components: {},
    props: {
        baseUrl: {
            type: String,
            required: false,
            default: projectBaseUrl,
        },
        endpoint: {
            type: String,
            required: false,
            default: 'projects',
        },
        filters: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        include: {
            type: String,
            required: false,
            default: '',
        },
        value: {
            type: String,
            required: false,
        },
        initItems: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            searchTerm: '',
            items: [] as Array<any>,
            offset: 0,
            limit: 20,
            infiniteId: 0,
            loading: false,
            isDirty: false,
            content: this.value,
        }
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value ? value.id : null)
            this.$emit('selected', value ? value : null)
        },
        name(company) {
            return company.name
                ? company.name
                : company.displayName
                ? company.displayName
                : company.officialName
        },

        async initSearch() {
            if (this.isDirty) {
                this.loading = true
                this.offset = 0
                this.infiniteId = new Date().getTime()
                this.items = await this.searchProject()
                this.loading = false
            }
        },

        async loadMore($state) {
            if (this.offset >= this.limit) {
                this.loading = true
                let res = await this.searchProject()
                this.items = [...this.items, ...res]

                if (res.length == this.limit) {
                    $state.loaded()
                } else {
                    $state.complete()
                }
                this.loading = false
            } else {
                $state.complete()
            }
        },

        async searchProject() {
            let { data } = await getRequest(
                getURL({
                    path: this.endpoint,
                    base: this.baseUrl,
                    params: {
                        ...this.filters,
                        ...(this.searchTerm && { 'filter[searchTerm]': this.searchTerm }),
                        'page[limit]': this.limit,
                        'page[offset]': this.offset,
                        include: this.include,
                    },
                })
            )

            return deserialise(data).data
        },
    },

    watch: {
        isDirty: {
            immediate: false,
            async handler() {
                this.initSearch()
            },
        },
        searchTerm: lodash.debounce(function (this) {
            this.initSearch()
        }, 600),
    },

    async mounted() {
        if (this.initItems.length > 0) {
            this.items = this.initItems
        } else if (this.value) {
            this.items = [await getProject(this.value, this.include)]
        }
    },
})

export default ProjectAutocomplete
